import { InstituteCardSkeleton } from '../../../components/institute-card/InstituteCardSkeleton';
import { PaginatedListPageSkeleton } from '../../../components/paginated-list/PaginatedListSkeleton';
import { ProgramCardSkeleton } from '../../../components/program-card/ProgramCardSkeleton';
import { ScholarshipCardSkeleton } from '../../../components/scholarship-card/ScholarshipCardSkeleton';
import { EligibleModule } from '../types';

interface EligibleModuleListSkeletonProps {
  module: EligibleModule;
}
export const EligibleModuleListSkeleton: React.FC<EligibleModuleListSkeletonProps> = ({ module }) => {
  const getEligibleItemSkeleton = (): React.ReactElement => {
    switch (module) {
      case 'Institutes':
        return <InstituteCardSkeleton />;
      case 'Programs':
        return <ProgramCardSkeleton />;
      case 'Scholarships':
        return <ScholarshipCardSkeleton />;
    }
  };
  const ItemSkeleton = getEligibleItemSkeleton();
  return <PaginatedListPageSkeleton isTitleVisible={false} ItemSkeleton={ItemSkeleton} />;
};
